export const css = {
    root: 'WnJJNezb',
    titleBlock: '-ApYrXsn',
    title: '_3GZLxtS_',
    eyebrow: '_2JCvnDol',
    openCloseIcon: '_81FULvSJ',
    close: '_3xKcRDSl',
    topicgroup: '_3RDEJPjY',
    item: 'AulsJPnB',
    setTitleBlock: '_2pWyVC5C',
    emptyTitleBlock: 'jPdkFpzO',
    actionBlock: '_3VzPetYV',
    setTitle: '_8bfZpReB',
    setProgress: '_3yEiWl6k',
    setProficiency: '_1Ok86Xn4',
    accordionLegend: '_2x61R8Vp',
    accordionLegendPlaceholder: '_3aGcbS3B',
    accordionLegendProgress: '_1wl0xzqD',
    accordionLegendProficiency: 'f6709W_F',
    accordionBody: '_2sU3AjEB',
    itemWrapper: '_3CLXIdJL',
    completed: '_28lv4WDd',
    shortDesc: '_1ej9-4WT',
    truncate: 'EzObvkGh',
    status: '_2aJjoAIj',
    progressBar: '_3OjGGwiD',
    whiteIcon: '_13TfTOO9',
    openTitle: 'BvLqMSR5',
    closedTitle: 'qm8fmKVH',
    statusLine: '_2puxutA8',
    ' _key': 'apic-theme/apic/book-widgets/topicaccordion'
};
export default css;
